var map = {
	"./axia/boomea/icons/word.svg": 328,
	"./axia/icons/word.svg": 337,
	"./boomea/boomea/icons/word.svg": 347,
	"./boomea/icons/word.svg": 366,
	"./simplifi/boomea/icons/word.svg": 370,
	"./simplifi/icons/word.svg": 379
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 876;
module.exports = webpackAsyncContext;